import { type AppDispatch, type RootState } from '../store/';
import { updateNumberOfWeeksBack } from './timeslots/timeSlotsReducer';

/**
 * Thunk selectors return values as well as dispatch actions.
 * Only use this pattern for exceptional cases where you need to both
 * read from the state and update it in a single operation.
 *
 * https://redux.js.org/usage/writing-logic-thunks#returning-values-from-thunks
 */

/**
 * A thunk that pops the last value from the numberOfWeeksBack stack and
 * returns it.
 * @returns last value from numberOfWeeksBack stack
 */
export const selectNumberOfWeeksBack =
  () => (dispatch: AppDispatch, getState: () => RootState) => {
    const selector = (state: RootState): number => {
      const { numberOfWeeksBack } = state.timeSlots;
      return numberOfWeeksBack[numberOfWeeksBack.length - 1] || 4;
    };
    const returnValue = selector(getState());
    dispatch(updateNumberOfWeeksBack());
    return returnValue;
  };
